
<tm2-patients-list
	[patients]="patients$ | async"
	(next)="onSubmit($event)">
</tm2-patients-list>
